import { Component, OnInit } from '@angular/core';
import {Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-network-marketing',
  templateUrl: './network-marketing.component.html',
  styleUrls: ['./network-marketing.component.scss']
})
export class NetworkMarketingComponent implements OnInit {
  private titleKey: string = "network-marketing";
  private subtitleKey: string = "network-marketing-desc";

  constructor(private title: Title, private translate: TranslateService) {
    this.title.setTitle(this.getTitle());
  }

  ngOnInit() {}

  getTitle() {
    return this.translate.instant(this.titleKey);
  }

  getSubtitle() {
    return this.translate.instant(this.subtitleKey);
  }
}
